import React from 'react';
import noemails from 'assets/images/noemails.svg';
//import Composemail from './Composemail'

const Nomails = () => {
  return (
    <div className='flex justify-center items-center h-full'>
      <div className='flex flex-col justify-center items-center gap-y-2 '>
        <img
          src={noemails}
          alt='not emails'
          className='h-32 2xl:h-40 3xl:h-44'
        />
        <h1 className='text-lg text-535353 font-semibold text-gray 3xl:text-2xl'>
          Select an item to read
        </h1>
        <p className='text-sm text-gray 2xl:text-lg 3xl:text-xl 3xl:font-semibold'>
          Nothing is selected
        </p>
      </div>
    </div>
  );
};

export default Nomails;
